/*
  const mySinePath = new SpiralTextPath({
    fill: 'black',
    fontSize: 24,
    fontFamily: 'Arial',
    text: 'Initial Text Initial Text Initial Text Initial',
    startRadius: 10,
    endRadius: 150,
    revolutions: 2,
    segments: 1000,
    clockwise: true,
    startAngle: 0
  });

  selectNode(mySinePath);
  //console.log("mySinePath", mySinePath);
  layer.add(mySinePath);
  layer.draw(); 
*/


class SpiralTextPath extends BaseTextPath {
  constructor(config) {
    super(config);

    this.className = 'SpiralTextPath';  
    this.attrs.type = "spiraltextpath";

    this.startRadius(config?.startRadius ?? 10);
    this.endRadius(config?.endRadius ?? 150);
    this.revolutions(config?.revolutions ?? 4);
  } 


  static getAttrNames() { return ['startRadius', 'endRadius', 'revolutions']; }
  static getDefaultAttrs() { return { startRadius: 10, endRadius: 150, revolutions: 4 }; }


  startRadius(v) {
    if (v === undefined) return this.attrs.startRadius ?? 0;
    this.attrs.startRadius = v;
    this.updatePath();
    return this;
  }


  endRadius(v) {
    if (v === undefined) return this.attrs.endRadius ?? 0;
    this.attrs.endRadius = v;
    this.updatePath();
    return this;
  }


  revolutions(v) {
    if (v === undefined) return this.attrs.revolutions ?? 0;
    this.attrs.revolutions = v;
    this.updatePath();
    return this;
  }


  updatePath() {
    this.setData(this.generateSvgPath({
        centerX: 0, 
        centerY: 0,
        startRadius: this.startRadius(), 
        endRadius: this.endRadius(), 
        revolutions: this.revolutions(),
        segments: this.revolutions() * 100, 
        clockwise: true, 
        startAngle: 0
    }));
  }
 
    /**
     * Generates an SVG path string for a spiral
     * @param {Object} options - Configuration options
     * @param {number} options.centerX - Center X coordinate
     * @param {number} options.centerY - Center Y coordinate
     * @param {number} options.startRadius - Initial radius (at the center)
     * @param {number} options.endRadius - Final radius (at the end)
     * @param {number} options.revolutions - Number of full rotations
     * @param {number} options.segments - Number of line segments per revolution (higher = smoother)
     * @param {boolean} [options.clockwise=true] - Direction of spiral (true = clockwise)
     * @param {number} [options.startAngle=0] - Starting angle in radians
     * @returns {string} SVG path data string (d attribute)
     */
    generateSvgPath({
        centerX,
        centerY,
        startRadius,
        endRadius,
        revolutions,
        segments = 100,
        clockwise = true,
        startAngle = 0
    }) {
        if (revolutions <= 0 || segments <= 0) {
            throw new Error('revolutions and segments must be positive');
        }

        const points = [];
        const totalAngle = revolutions * 2 * Math.PI;
        const angleStep = totalAngle / segments;
        const direction = clockwise ? 1 : -1;

        // Generate points along the spiral
        for (let i = 0; i <= segments; i++) {
            const t = i / segments; // 0 to 1
            const angle = startAngle + direction * t * totalAngle;
            const radius = startRadius + t * (endRadius - startRadius);

            const x = centerX + radius * Math.cos(angle);
            const y = centerY + radius * Math.sin(angle);

            points.push({ x, y });
        }

        // Build SVG path: Move to first point, then line to others
        let path = `M ${points[0].x} ${points[0].y}`;
        for (let i = 1; i < points.length; i++) {
            path += ` L ${points[i].x} ${points[i].y}`;
        }

        return path;
    }  
}
